<template>
  <CheckboxGroup
    v-model="data.value"
    :options="data.options"
    @change="bindChange"
  >
    <CheckboxItem
      :class="[data.show_type ? 'checkbox-item-' + data.show_type : '']"
      v-for="(item, index) in data.options"
      :key="index"
      :value="item.key"
      :data="item"
    >
      <div
        class="checkbox-text"
        :style="{
          background: data.value.includes(item.key)
            ? theme.checkColor
            : theme.notCheckColor
        }"
        v-if="item.value && !item.que_answer_icon"
        v-html="item.value"
      ></div>
      <div class="radio-image" v-if="item.que_answer_icon">
        <img style="width: 100%" :src="item.que_answer_icon" alt="" />
        <div
          class="active iconfont icon-gou"
          v-show="data.value.includes(item.key)"
          :style="{ background: theme.checkColor }"
        ></div>
      </div>
      <textarea
        v-if="item.que_answer_attr && data.value.includes(item.key)"
        class="raido-input"
        @click.stop
        v-model="item.inputValue"
        rows="1"
        placeholder="请输入(选填)"
      ></textarea>
      <!-- <van-field  v-model="item.inputValue" rows="1" type="textarea" placeholder="请输入(选填)" /> -->
    </CheckboxItem>
  </CheckboxGroup>
</template>
<script>
import CheckboxItem from './checkbox/checkbox.vue'
import CheckboxGroup from './checkbox/checkbox-group.vue'
export default {
  components: {
    CheckboxGroup,
    CheckboxItem
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    bindChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.checkbox-text {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 12px 4px;
  border-radius: 26px;
  box-sizing: border-box;
  height: 100%;
}

.checkbox-item-2 {
  width: 138px;
}

.raido-input {
  color: rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  margin-top: 10px;
  width: 287px;
  height: 44px;
  background: #ffffff;
  border-radius: 22px;
  border: 3px solid #373d52;
  padding: 6px 10px;
  box-sizing: border-box;
}
.raido-input::placeholder {
  line-height: 28px;
}
.radio-image {
  position: relative;

  .active {
    position: absolute;
    right: 24px;
    top: 50%;
    color: #fff;
    transform: translate(0%, -50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #9f91fe;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
